const bklrRoutes: any = [
    {
        path: 'bklr',
        name: 'bklr',
        component: () => import('@/views/Project/Bklr/views/Index.vue'),
        beforeEnter: (to, from, next) => {
            next()
        },
    },
]

export default bklrRoutes
